import React from 'react';
import i18n from '../../../../../i18n';

import { makeStyles } from '@material-ui/core/styles';
import { Text, TextTypography } from 'components/Text/Text';
import stickerExampleRu from 'assets/images/marketingWidgetSticker_ru.png';
import stickerExampleEn from 'assets/images/marketingWidgetSticker_en.png';
import { StickerDownloadButton } from 'pages/MarketingMaterials/components/StickerDownloadButton';

const useStyles = makeStyles(theme => ({
    container: {
        width: '100%',
        height: '100%',
        [theme.breakpoints.up('sm')]: {
            height: 256,
        },
        background: theme.palette.brandPrimary.lightest,
        borderRadius: 20,
        padding: theme.spacing(3),
        display: 'flex',
        justifyContent: 'space-between',
    },
    flexWrap: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    text: {
        marginTop: theme.spacing(2),
        whiteSpace: 'pre-line',
    },
    button: {
        marginBottom: theme.spacing(1),
        [theme.breakpoints.down(425)]: {
            marginTop: theme.spacing(5),
        },
    },
    stickerExample: {
        marginLeft: theme.spacing(3),
        width: 147,
        maxHeight: 207,
        [theme.breakpoints.down(425)]: {
            display: 'none',
        },
    },
}));

export const MarketingWidget = () => {
    const classes = useStyles();
    const {
        t,
        i18n: { language },
    } = i18n.useTranslation();

    const stickerExample = language === 'ru' ? stickerExampleRu : stickerExampleEn;
    return (
        <div className={classes.container}>
            <div className={classes.flexWrap}>
                <div>
                    <Text typography={TextTypography.LEAD_ACCENT}>{t('vendor:dashboard:marketingWidget:title')}</Text>
                    <Text className={classes.text} typography={TextTypography.BODY}>
                        {t('vendor:dashboard:marketingWidget:info')}
                    </Text>
                </div>
                <div className={classes.button}>
                    <StickerDownloadButton />
                </div>
            </div>
            <img src={stickerExample} className={classes.stickerExample} />
        </div>
    );
};
